import axios from "axios";


export const getBingAccount = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/bingaccount/getBingAccount/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editBingAccount = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/bingaccount/editBingAccount",
      data
    )
    .then((res) => res.data);
};
